module.exports = {
	"annoyingEmail": "Don't like these annoying e-mails?",
	"clickButton": "To do so, all you need is to click on the button below.",
	"hi": "Hi there",
	"niceDay": "Thank you and have a nice day!",
	"unsubscribe": "Unsubscribe"
}


//////////////////
// WEBPACK FOOTER
// /private/var/folders/n9/yczdnstj3wdc9q5tzm6d45c00000gp/T/maison-encans-auex-website/~/@auex/locales/lib/en/emailTemplate.json5
// module id = 1928
// module chunks = 6